import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const list = async (hotelId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/promotion`
  const result = await bService.get(url)

  return result
}

const detail = async (hotelId, promotionId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/promotion/${promotionId}`
  const result = await bService.get(url)

  return result
}

const create = async (hotelId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/promotion`
  const result = await bService.post(url, data)

  return result
}

const update = async (hotelId, promotionId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/promotion/${promotionId}`
  const result = await bService.put(url, data)

  return result
}

const updateIsDefault = async (hotelId, promotionId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/promotion/${promotionId}/is-default`
  const result = await bService.put(url, data)

  return result
}

const remove = async (hotelId, promotionId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/promotion/${promotionId}`
  const result = await bService.remove(url)

  return result
}

const removePeriod = async (hotelId, promotionId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/promotion/${promotionId}/delete-period`
  await bService.remove(url, data)
}

export default {
  list,
  create,
  update,
  updateIsDefault,
  remove,
  detail,
  removePeriod
}
